import { ExternalConnection } from '@griply/types';
import { useMemo } from 'react';

export const useExternalCalendarConnections = (
  data: ExternalConnection[] | undefined,
): ExternalConnection[] => {
  return useMemo(() => data ?? [], [data]);
};
